import { takeLatest, call, put, select } from 'redux-saga/effects'
import { startLoading, stopLoading, enqueueSnackbar } from '../root/actions'
import * as actions from './actions'
import { getSagasMsgs } from '../root/selectors'
import axios from 'axios'
import qs from 'qs'

export const watchHotSwapSaga = [
    takeLatest(actions.HOTSWAP_GET_LOCATIONS_REQUEST, getLocations),
    takeLatest(actions.HOTSWAP_GET_LOCATIONS_ADMIN_REQUEST, getLocationsAdmin),
    takeLatest(actions.HOTSWAP_GET_BY_ID_REQUEST, getHotswapById),
    takeLatest(actions.HOTSWAP_UPDATE_REQUEST, updateHotswap)
]

function* getLocations(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(getLocationsRequest, action.filters)
        yield put(actions.getLocationsSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.getLocationsError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getLocationsByCustomerIdEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function getLocationsRequest(filters) {
    const response = await axios.get(`${process.env.API_URL}/hotswaps`, {
        params: {
            ...filters
        },
        paramsSerializer: params => {
            return qs.stringify({ ...params })
        }
    })
    return response.data
}

function* getLocationsAdmin(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(getLocationsAdminRequest, action.filters)
        yield put(actions.getLocationsAdminSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.getLocationsAdminError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getLocationsByCustomerIdEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function getLocationsAdminRequest(filters) {
    const response = await axios.get(
        `${process.env.API_URL}/hotswaps/all-hotswaps`,
        {
            params: {
                ...filters
            },
            paramsSerializer: params => {
                return qs.stringify({ ...params })
            }
        }
    )
    return response.data
}

function* getHotswapById(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(getHotswapByIdRequest, action.id)
        yield put(actions.getHotSwapByIdSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.getHotSwapByIdError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getLocationsByCustomerIdEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function getHotswapByIdRequest(id) {
    const response = await axios.get(`${process.env.API_URL}/hotswaps/${id}`)
    return response.data
}

function* updateHotswap(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const data = yield call(updateHotswapRequest, action.id, action.payload)
        yield put(actions.updateHotSwapSuccess(data))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.updateHotSwapError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getLocationsByCustomerIdEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function updateHotswapRequest(id, payload) {
    const response = await axios.patch(
        `${process.env.API_URL}/hotswaps/${id}`,
        payload
    )
    return response.data
}
